import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import ModalFooter from '../../../../../components/modal-footer-actions';
import { AutomationRulesContext } from '../../context';
import { AutomationRule } from '../../props';
import { useContextTypes } from 'ui-components/hooks/use-context-types';
import ModalPortal from '../../../../../components/modal-portal';
import messages from '../../messages';
import style from './delete-rule.module.less';

const DeleteRuleModal = () => {
  useContextTypes('DeleteRuleModal', AutomationRulesContext, {
    selectedRule: AutomationRule.isRequired,
    deleteRule: PropTypes.func.isRequired,
    closeAnyModal: PropTypes.func.isRequired,
  });
  const { selectedRule, deleteRule: onDeleteRule, closeAnyModal } = useContext(AutomationRulesContext);
  const { name, automationRuleId } = selectedRule;

  const _onDeleteRule = useCallback(async () => {
    await onDeleteRule(automationRuleId);
    // intentional choice to close modal even if call fails
    closeAnyModal();
  }, [automationRuleId, onDeleteRule, closeAnyModal]);

  return (
    <ModalPortal containerId='delete-automation-rule-modal' onClose={closeAnyModal}>
      <Modal>
        <ModalHeader closeModal={closeAnyModal}>
          <FormattedMessage {...messages.deleteAutomationRule} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <div>
            <FormattedMessage {...messages.deleteAutomationRuleConfirmation} />
          </div>
          <div className={style.delete}>{name}</div>
        </ModalBody>
        <ModalFooter
          actionMessage={<FormattedMessage {...messages.delete} />}
          actionTheme='danger'
          cancelMessage={<FormattedMessage {...messages.cancel} />}
          onAction={_onDeleteRule}
          onCancel={closeAnyModal}
        />
      </Modal>
    </ModalPortal>
  );
};

export default DeleteRuleModal;
